import { useCallback, useRef, useState } from 'react';

import { stringUtils } from '@pukka/common/utils';
import { Button, Icon, Input, Modal } from '@pukka/ui-components';

interface ResendReceiptModalProps {
  readonly open?: boolean;
  readonly loading?: boolean;
  readonly onToggleModal?: (open: boolean) => void;
  readonly onSend?: (email: string) => void;
}

function ResendReceiptModal({ open, loading, onToggleModal, onSend }: ResendReceiptModalProps) {
  const [isValid, setIsValid] = useState(false);
  const value = useRef('');

  const onSetValue = useCallback((val: string) => {
    value.current = val;
    setIsValid(stringUtils.isEmail(val));
  }, []);

  const onClickSend = useCallback(() => {
    onSend?.(value.current);
  }, [onSend]);

  return (
    <Modal unwrap open={open} onOpenChange={onToggleModal}>
      <Modal.Content className="bg-neutral-50 md:w-144">
        <Modal.Title className="flex-row justify-between">
          Resend Email
          <Modal.Close asChild>
            <Button variant="nude" size="none" className="rounded-md">
              <Icon icon="close" color="white" />
            </Button>
          </Modal.Close>
        </Modal.Title>
        <Modal.Body className="my-8 max-h-128 px-5">
          <Input type="email" placeholder="Email" onChangeValue={onSetValue} />
        </Modal.Body>
        <Modal.Footer
          onCancel
          buttons={
            <Modal.Button loading={loading} disabled={!isValid} onClick={onClickSend}>
              Send
            </Modal.Button>
          }
        />
      </Modal.Content>
    </Modal>
  );
}

export { ResendReceiptModal };
